import { TwilioRoomEvents, TwilioTrackKind } from './constants';
export const twilioDebugEnabled = true;

export const addDebugListenersForRoom = (room) => {
  if (!twilioDebugEnabled) {
    return;
  }

  room.on('disconnected', (data) => {
    console.log('ROOM-EVENT: disconnected', data);
  });
  room.on('dominantSpeakerChanged', (data) =>
    console.log('ROOM-EVENT: dominantSpeakerChanged', data)
  );
  room.on('participantReconnected', (data) =>
    console.log('ROOM-EVENT: participantReconnected', data.identity, data)
  );
  room.on('participantReconnecting', (data) =>
    console.log('ROOM-EVENT: participantReconnecting', data.identity, data)
  );
  room.on('reconnected', (data) => console.log('ROOM-EVENT: reconnected', data));
  room.on('reconnecting', (data) => console.log('ROOM-EVENT: reconnecting', data));
  room.on('trackDimensionsChanged', (data) =>
    console.log('ROOM-EVENT: trackDimensionsChanged', data.name, data)
  );
  room.on('trackDisabled', (publication, participant) =>
    console.log('ROOM-EVENT: trackDisabled', participant.identity, publication.trackName)
  );
  room.on('trackEnabled', (publication, participant) =>
    console.log('ROOM-EVENT: trackEnabled', participant.identity, publication.trackName)
  );
  room.on('trackMessage', (data, track, participant) =>
    console.log('ROOM-EVENT: trackMessage', participant.identity, track.name, data)
  );
  room.on('trackPublished', (publication, participant) =>
    console.log('ROOM-EVENT: trackPublished', participant.identity, publication.trackName)
  );
  room.on('trackPublishPriorityChanged', (priority, publication, participant) =>
    console.log(
      'ROOM-EVENT: trackPublishPriorityChanged',
      participant.identity,
      publication.trackName,
      priority
    )
  );
  room.on('trackStarted', (track, participant) =>
    console.log('ROOM-EVENT: trackStarted', participant.identity, track.name)
  );
  room.on('trackSubscribed', (track, publication, participant) =>
    console.log('ROOM-EVENT: trackSubscribed', participant.identity, publication.trackName, track)
  );
  room.on('trackSubscriptionFailed', (error, publication, participant) =>
    console.log(
      'ROOM-EVENT: trackSubscriptionFailed',
      participant.identity,
      publication.trackName,
      error
    )
  );
  room.on('trackSwitchedOff', (track, publication, participant) =>
    console.log('ROOM-EVENT: trackSwitchedOff', participant.identity, publication.trackName, track)
  );
  room.on('trackSwitchedOn', (track, publication, participant) =>
    console.log('ROOM-EVENT: trackSwitchedOn', participant.identity, publication.trackName, track)
  );
  room.on('trackUnpublished', (publication, participant) =>
    console.log('ROOM-EVENT: trackUnpublished', participant.identity, publication.trackName)
  );
  room.on('trackUnsubscribed', (track, publication, participant) =>
    console.log('ROOM-EVENT: trackUnsubscribed', participant.identity, publication.trackName, track)
  );
};

export const addDebugListenersForParticipant = (participant) => {
  if (!twilioDebugEnabled) {
    return;
  }

  const name = participant.identity;

  participant.on('disconnected', (value) => {
    console.log('PARTICIPANT-EVENT: disconnected', name, value);
  });
  participant.on('trackDimensionsChanged', (track) =>
    console.log('PARTICIPANT-EVENT: trackDimensionsChanged', name, track.name)
  );
  participant.on('trackDisabled', (track) =>
    console.log('PARTICIPANT-EVENT: trackDisabled', name, track.name)
  );
  participant.on('trackEnabled', (track) =>
    console.log('PARTICIPANT-EVENT: trackEnabled', name, track.name)
  );
  participant.on('trackPublicationFailed', (track) =>
    console.log('PARTICIPANT-EVENT: trackPublicationFailed', name, track.name)
  );
  participant.on('trackStarted', (track) =>
    console.log('PARTICIPANT-EVENT: trackStarted', name, track.name)
  );
  participant.on('trackStopped', (track) =>
    console.log('PARTICIPANT-EVENT: trackStopped', name, track.name)
  );
};

export const addDebugListenersForDataTrack = (participantName, track) => {
  if (!twilioDebugEnabled) {
    return;
  }

  track.on('message', (value) => console.log('TRACK-EVENT: message', participantName, value));
  track.on('switchedOff', (value) =>
    console.log('TRACK-EVENT: switchedOff', participantName, value)
  );
  track.on('switchedOn', (value) => console.log('TRACK-EVENT: switchedOn', participantName, value));
};

export const addDebugListeners = (room) => {
  addDebugListenersForRoom(room);
  room.on(TwilioRoomEvents.ParticipantConnected, (participant) => {
    addDebugListenersForParticipant(participant);
  });
  room.on(TwilioRoomEvents.TrackPublished, (publication, participant) => {
    if (publication.kind === TwilioTrackKind.Data) {
      addDebugListenersForDataTrack(participant.identity, publication);
    }
  });
};
